<template>
  <!-- 退出 -->
  <div >
    <v-dialog
      class="del"
      name="dialog2"
      v-model="isShow"
      :title="dialogTitle"
      :modal="true"
      :width="560"
      :height="204"
      @confirm="handleConfirm"
      @after-close="handleAfterClose"
      v-bind:confirmButtonText="sureout"
      append-to-body
    >确定要退出腾达云管理系统吗？</v-dialog>
  </div>
</template>

  <script>
export default {
  props: {
    showInputDialog: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      sureout: "退出",
      dialogTitle: "退出",
      isShow: false
    };
  },
  created() {
    // this.ruleForm.upgradeType = 0
  },
  watch: {
    showInputDialog(newVal) {
      this.isShow = newVal;
    }
  },
  methods: {
    handleConfirm() {
      this.$emit("change");
      this.showInputDialog = false;
      this.loginout();
    },
    handleAfterClose() {
      this.$emit("change");
    },
    loginout() {
      const Authorizationstr = sessionStorage.getItem("Authorization") || "";
      let submitData = {
        access_token: Authorizationstr.slice(7)
      };
      this.$post(
        "/td/td-iot-api/iot/logout/v1",
        submitData,
        false
      ).then(res => {
        let code = +res.code;
        if (code === 0) {
          this.$message.success(res.msg);
          sessionStorage.removeItem("Authorization");
          window.location.href = "/login.html";
        } else {
          this.$message.error(res.msg);
        }
      });
    }
  },
  beforeDestroy() {}
};
</script>

  <style lang="scss">
</style>
